export default "__VITE_ASSET__5481dbdd__"